/*
 * tnf-search-page-typo.js
 *
 * Adds a "Did you mean: <suggestion>?" hint to the standard /search results page
 * when the customer's query looks like a typo of a known brand or category.
 *
 * Works on:
 *   - Results-found page  -> injects above .collection__title
 *   - Empty/no-results    -> injects above .empty-state__description
 *
 * Clicking the suggestion navigates to /search?q=<corrected>&type=product.
 * Dictionary + matching engine mirrors tnf-search-typo-suggest.js (predictive overlay).
 * Loaded only by sections/main-search.liquid so it stays off non-search pages.
 */
(function () {
  "use strict";
  if (window.__tnfSearchPageTypoLoaded) return;
  window.__tnfSearchPageTypoLoaded = true;

  var VENDORS = ["321GLO","3D Energy","4ever Fit","ABE","alani nu","Allmax Nutrition","Allo","Aloha","Alora Naturals","Alpha Prime","ALT","Ambrosia Planta","Animal","Applied Nutrition","Aqua Omega","Arnold","ATF Sports","Australian Gold","Barebells","Believe Supplements","Better Bears","Better Bovine","Better Than Good","Betty Crocker","Biosteel","Bite and More","BlenderBottle","Bowmar Nutrition","Brain Gains","Bucked Up","Built Bar","CanDo Foam Rollers","Candy Can","CanPrev","Catalina Crunch","Cellucor","Certified Lab","ChocoRite","ChocZero","ChunkyFit","Crisp Power","David Protein","Designer Skin","Diva Rice","Double Wood Supplements","Effin' Good Snacks","EHP Labs","elavi","Emerald Bay","Ener-LIfe","FeelingOK","Fiber Gourmet","Finaflex","Fitcrunch","fizzique","Flavolicious","Freshfield","FULFIL","G Butter","G Hughes","Genius Gourmet","Genuine Health","GFUEL","GHOST","Go Nutrition","GoFit","Goodles","Gorilla Mind","Grenade","Grit Nutrition","Grizzly","Guerrero","HangryBoy","Heal+Co","Healthy Hippo","Helixx","Herbaland","Hershey's","Highkey","Himalaya","HiProtein","Hydra Cup","Hydro Case","Ice Shaker","IQ Bar","Iron Bull Strength","Iron Kingdom","IWON Organics","Jell-O","Joseph's Bakery","Joyride","JWOWW","Kalaya","keto wise","Khloud","Killer Labz","Kingline Nutition","KissMyKeto","Krisda","La Banderita","Land Art","Leanfit","Legendary Foods","Lenny & Larry","LIFT TECH","Liquid Grip","Magic Spoon","Mammoth","Max Protein","Max Sweets","Maxi Nutrition","Mid-Day Squares","Mind Blow","Misfits","Mission","Mountain Joe's","MOVEWEIGHT","Mr. Tortilla","Mrs Taste","MuscleMac","MuscleMeds","MuscleSport","MuscleTech","Mutant","My Protein","MyProtein","Nano Supplements","Natural Stacks","New Nordic Supplements","NICK'S","No Cow","North Coast Naturals","Nova Forme","Nu Life","Nutrabolics","Nutraphase","NutriWise","Nutry Nuts","Nuts 'n More","Nuun Sport","Oh my spice","Ohana Liquids","Ole Mexican Foods","Omaha","ONE Bar","Optimum Nutrition","Orange Naturals","Palmini","PB2","PERF4M Nutrition","Performa","PEScience","Pharma-Grade","PhD","Platinum Naturals","Power Crunch","prairie naturals","PRIME","ProBites","Progressive","Protein Candy","Protein Source","Prozis","Pure Vita Labs","Purus Labs","PVL","PWR4ALL","qnt","Quamtrax Nutrition","Quest","Quest Nutrition","Rabeko","Red Vines","Redcon1","Redefine Foods","Reese","RenewLife","repp sports","Revive MD","Rip Van","Rule1","RYSE","SANA","Santte Foods","schoolyard snacks","Scivation","Shameless Snacks","Shrewd Food","SIIP","Simply Scrumptous","SimplyProtein","Sinfit Nutrition","Sinless","SIS","SmartBaking","Smarter Snacks","Snackhouse","SNCK","Soloray","Southern Recipe","Sportneer","SteelFit","Steeves","Swedish Beauty","Swedish Protein Deli","sweet nothings","Sweet Nutrition Canada","Swerve","SWISS Natural","Tested Nutrition","Think!","TRUBAR","TRUELY","TRUFF","USN","Velomix","VMI Sports","WANA","warrior supplements","WELLBAR","Wilde","Wispy Protein","XPLabs","Zone Smelling Salts"];
  var CATEGORIES = ["protein powder","protein bar","protein bars","whey protein","whey isolate","vegan protein","casein","mass gainer","pre-workout","preworkout","creatine","bcaa","eaa","amino acids","glutamine","electrolytes","energy drink","energy drinks","caffeine","multivitamin","vitamins","omega 3","fish oil","collagen","fat burner","thermogenic","l-carnitine","carnitine","greens","probiotics","nootropic","sleep aid","testosterone booster","testosterone","test booster","test boosters","testo booster","tribulus","tongkat ali","ashwagandha","zinc magnesium","zma","dhea","fenugreek","mens health","mens wellness","protein snacks","protein snack","keto snacks","keto bars","keto cookies","keto chocolate","low carb","sugar free","chips","cookies","candy","chocolate","peanut butter","shaker","shaker bottle","tanning lotion","gift card","meal replacement","protein cookies","protein puffs","protein chips","rice cakes","jerky","beef jerky","gummies","protein gummies","cereal","protein cereal","granola","protein granola","vegan snacks","gluten free","diabetic friendly","high protein"];

  function normalize(s) {
    return String(s || "").toLowerCase().replace(/[^a-z0-9]+/g, "");
  }
  function softNormalize(s) {
    return String(s || "").toLowerCase().replace(/[^a-z0-9 ]+/g, " ").replace(/\s+/g, " ").trim();
  }

  var POOL = [];
  function addPoolEntry(display) {
    var key = normalize(display);
    var soft = softNormalize(display);
    if (!key || key.length < 3) return;
    POOL.push({ display: display, key: key, soft: soft });
  }
  VENDORS.forEach(addPoolEntry);
  CATEGORIES.forEach(addPoolEntry);

  // High-confidence overrides for real-world typos/variants seen in GA4 search
  // data (2026-06-13) that Levenshtein's distance threshold misses. Keyed by
  // NORMALIZED query (lowercase, alnum only). Deterministic — only fires on an
  // exact normalized match, so normal queries are untouched. Mirrors the map
  // in tnf-search-typo-suggest.js (keep the two in sync).
  var OVERRIDES = {
    "barbell": "Barebells",
    "barbells": "Barebells",
    "barebell": "Barebells",
    "barbel": "Barebells",
    "probite": "ProBites",
    "probits": "ProBites",
    "chocolatezero": "ChocZero",
    "davidbar": "David Protein",
    "davidbars": "David Protein",
    "davidprotien": "David Protein",
    "protien": "protein powder",
    "magicspoons": "Magic Spoon"
  };

  function levenshtein(a, b, cap) {
    var n = a.length, m = b.length;
    if (n === 0) return m;
    if (m === 0) return n;
    if (Math.abs(n - m) > cap) return cap + 1;
    var prev = new Array(m + 1);
    for (var j = 0; j <= m; j++) prev[j] = j;
    for (var i = 1; i <= n; i++) {
      var curr = [i];
      var rowMin = i;
      for (var k = 1; k <= m; k++) {
        var cost = a.charCodeAt(i - 1) === b.charCodeAt(k - 1) ? 0 : 1;
        var v = Math.min(prev[k] + 1, curr[k - 1] + 1, prev[k - 1] + cost);
        curr.push(v);
        if (v < rowMin) rowMin = v;
      }
      if (rowMin > cap) return cap + 1;
      prev = curr;
    }
    return prev[m];
  }

  function suggestCorrection(query) {
    var raw = String(query || "").trim();
    if (raw.length < 3) return null;
    var qKey = normalize(raw);
    var qSoft = softNormalize(raw);
    if (qKey.length < 3) return null;

    for (var i = 0; i < POOL.length; i++) {
      if (POOL[i].key === qKey || POOL[i].soft === qSoft) return null;
    }

    // Curated overrides — catch real-world typos Levenshtein's threshold misses.
    if (OVERRIDES[qKey]) return { suggestion: OVERRIDES[qKey], distance: 1 };

    if (qKey.length >= 3 && qKey.length <= 6) {
      var prefixBest = null;
      for (var p = 0; p < POOL.length; p++) {
        var pe = POOL[p];
        if (pe.key.indexOf(qKey) === 0 && pe.key.length >= qKey.length + 2) {
          if (!prefixBest || pe.key.length < prefixBest.key.length) prefixBest = pe;
        }
      }
      if (prefixBest) return { suggestion: prefixBest.display, distance: 0 };
    }

    var maxDist;
    if (qKey.length <= 5) maxDist = 1;
    else if (qKey.length <= 8) maxDist = 2;
    else maxDist = Math.max(2, Math.ceil(qKey.length * 0.28));

    var best = null;
    for (var j = 0; j < POOL.length; j++) {
      var entry = POOL[j];
      var d1 = levenshtein(qKey, entry.key, maxDist);
      var d2 = levenshtein(qSoft, entry.soft, maxDist);
      var d = Math.min(d1, d2);
      if (d <= maxDist) {
        var score = d;
        if (entry.key.indexOf(qKey) !== -1 || qKey.indexOf(entry.key) !== -1) score -= 0.5;
        if (!best || score < best.score) best = { display: entry.display, distance: d, score: score };
      }
    }

    // Token-level fallback: for multi-word vendor/category names ("Optimum Nutrition",
    // "Lenny & Larry"), also try matching the query against the FIRST significant
    // token. Catches "optmum" -> "Optimum Nutrition", "lennie" -> "Lenny & Larry".
    for (var tj = 0; tj < POOL.length; tj++) {
      var et = POOL[tj].soft.split(" ");
      if (et.length < 2) continue;
      for (var ti = 0; ti < et.length; ti++) {
        var tok = et[ti];
        if (tok.length < 4) continue;
        var td = levenshtein(qKey, tok, maxDist);
        if (td <= maxDist) {
          var ts = td + 0.2; // small penalty vs full-string match
          if (!best || ts < best.score) best = { display: POOL[tj].display, distance: td, score: ts };
        }
      }
    }

    if (!best) return null;
    if (normalize(best.display) === qKey) return null;
    return { suggestion: best.display, distance: best.distance };
  }

  var STYLE_ID = "tnf-search-page-typo-style";
  var NODE_ID = "tnf-search-page-typo";

  function injectStyle() {
    if (document.getElementById(STYLE_ID)) return;
    var style = document.createElement("style");
    style.id = STYLE_ID;
    style.textContent = [
      "#" + NODE_ID + "{",
      "  display:block;",
      "  margin:0 0 16px 0;",
      "  padding:12px 16px;",
      "  background:#fff8d6;",
      "  border:1px solid #ffd800;",
      "  border-radius:8px;",
      "  font-family:Barlow,system-ui,sans-serif;",
      "  font-size:15px;",
      "  line-height:1.4;",
      "  color:#1e2d7d;",
      "}",
      "#" + NODE_ID + " .tnf-spt-label{font-weight:500;margin-right:4px;}",
      "#" + NODE_ID + " a.tnf-spt-link{color:#1e2d7d;font-weight:700;text-decoration:underline;}",
      "#" + NODE_ID + " a.tnf-spt-link:hover{color:#006fdb;}",
      "@media (max-width:480px){#" + NODE_ID + "{font-size:14px;padding:10px 12px;}}"
    ].join("");
    document.head.appendChild(style);
  }

  function buildNode(suggestion, originalQuery) {
    var wrap = document.createElement("div");
    wrap.id = NODE_ID;
    wrap.setAttribute("role", "status");
    wrap.setAttribute("aria-live", "polite");

    var label = document.createElement("span");
    label.className = "tnf-spt-label";
    label.textContent = "Did you mean: ";

    var a = document.createElement("a");
    a.className = "tnf-spt-link";
    a.href = "/search?type=product&q=" + encodeURIComponent(suggestion);
    a.textContent = suggestion;
    a.addEventListener("click", function () {
      try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "tnf_search_page_typo_click",
          original_query: originalQuery,
          suggested_query: suggestion
        });
      } catch (e) {}
    });

    var qm = document.createTextNode("?");

    wrap.appendChild(label);
    wrap.appendChild(a);
    wrap.appendChild(qm);
    return wrap;
  }

  function injectInto(target) {
    if (!target || !target.parentNode) return false;
    if (document.getElementById(NODE_ID)) return true;
    var url = new URL(window.location.href);
    var q = (url.searchParams.get("q") || "").trim();
    if (!q || q.length < 3) return false;
    var sugg = suggestCorrection(q);
    if (!sugg) return false;
    injectStyle();
    var node = buildNode(sugg.suggestion, q);
    target.parentNode.insertBefore(node, target);
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "tnf_search_page_typo_shown",
        original_query: q,
        suggested_query: sugg.suggestion,
        edit_distance: sugg.distance
      });
    } catch (e) {}
    return true;
  }

  function tryRender() {
    if (window.location.pathname.indexOf("/search") !== 0) return false;
    var heading =
      document.querySelector(".collection__title") ||
      document.querySelector(".empty-state__description") ||
      document.querySelector(".empty-state__heading");
    if (!heading) return false;
    return injectInto(heading);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", tryRender);
  } else {
    tryRender();
  }
  // Retry once in case the section renders late
  setTimeout(tryRender, 500);
})();
